export default __webpack_public_path__ + "static/media/SukainaCharafEddine.431d1380.jpeg";